import _ from 'lodash';
import React from 'react';
import {useGroupedChatSessions} from '../../../../data/hooks/chat/useGroupedChatSessions';
import {useI18n} from '../../../../data/hooks/i18nHooks';
import WaitWhileBusy from '../../../WaitWhileBusy';
import ListItem from '../../../elements/DEPRECATED_ListItem';
import Link from '../../../elements/Link';
import ScreenTitle from '../../../elements/ScreenTitle/ScreenTitle';
import ScrollableList from '../../../elements/ScrollableList';
import TopBar from '../../../elements/TopBar/TopBar';
import Screen from '../../Screen';

function GlobalChatSessions(props) {
    const {} = props,
        i18n = useI18n(),
        groupedSessions = useGroupedChatSessions();

    const header = (
        <div>
            <TopBar returnURL=".." chat />
            <ScreenTitle screen={i18n['label.chat.title']} />
        </div>
    );

    return (
        <Screen header={header}>
            {groupedSessions.length ? (
                <ScrollableList savePosition={'GlobalChatSessions'}>
                    {groupedSessions.map(session => {
                        return (
                            <div key={session.user.id}>
                                <Link href={['.', session.sessions[0].id].join('/')}>
                                    <ListItem icon={session.user.image_url} altIcon={'img/no_avatar.png'} next="next" tagName="div">
                                        <div className="text main">{_.compact([session.user.first_name, session.user.last_name]).join(' ')}</div>
                                        <div className="text small">
                                            {session.user.position}
                                            <br />
                                            {session.user.company}
                                        </div>
                                    </ListItem>
                                </Link>
                            </div>
                        );
                    })}
                </ScrollableList>
            ) : (
                <div className="content">
                    <img src="img/pointer_up.png" style={{width: 15, height: 48, marginLeft: 'auto', marginRight: 100, display: 'block'}} />
                    <img src="img/no_chats.png" style={{width: '100%'}} />
                    <div className="text-center text marginTop">{i18n['label.tip.no-chat']}</div>
                </div>
            )}
        </Screen>
    );
}

export default props => (
    <WaitWhileBusy>
        <GlobalChatSessions {...props.match.params} />
    </WaitWhileBusy>
);
